export default __webpack_public_path__ + "static/noon-995a480cc89fb308670ef4f43df310d9.png";